import React from 'react';
import { TextArea } from '@progress/kendo-react-inputs';

/**
 * A base textarea component.
 *
 * @typedef {React.ComponentProps<TextArea>} TelerikTextAreaProps
 *
 * @typedef {Object} AdditionalTextAreaProps
 * @property {string} [dataTestId] Data test Id.
 *
 * @param {TelerikTextAreaProps & AdditionalTextAreaProps} props Component props. Expands Telerik TextArea's props.
 * @param {React.Ref<HTMLDivElement>} ref
 * @returns {React.ReactElement} Base textarea component.
 */
const BaseTextArea = ({ dataTestId, ...props }) => <TextArea data-testid={dataTestId} {...props} />;

export default BaseTextArea;
